// List of ship systems eligible for Armoured Bulkhead protection
// Each entry includes an ID (for lookup) and a display name (for UI)

export interface ProtectableShipSystem {
  id: string;
  name: string;
}

export const PROTECTABLE_SHIP_SYSTEMS: ProtectableShipSystem[] = [
  { id: "bridge", name: "Bridge" },
  { id: "computer", name: "Computer" },
  { id: "sensors", name: "Sensors" },
  { id: "powerPlant", name: "Power Plant" },
  { id: "maneuverDrive", name: "Maneuver Drive" },
  { id: "jumpDrive", name: "Jump Drive" },
  { id: "reactionDrive", name: "Reaction Drive" }, // Added as requested
  { id: "fuelTanks", name: "Fuel Tanks" },
  { id: "staterooms", name: "Staterooms" },
  { id: "cargo", name: "Cargo Hold" },
  { id: "weapons", name: "Weapons" },
  { id: "hangar", name: "Hangar Bay" },
  { id: "lifeSupport", name: "Life Support" },
  { id: "medicalBay", name: "Medical Bay" },
  { id: "droneBay", name: "Drone Bay" },
  { id: "externalSystems", name: "External Systems" },
  { id: "internalSystems", name: "Internal Systems" },
  { id: "modularHull", name: "Modular Hull" },
];
